<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{ response.message}}</strong>
        </b-alert>
         <b-card v-if="displayCentreData">
          <div slot="header">
            Information du centre d'appel <strong></strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="entite_id">Entite *</label>
                <el-select style="display:block;"
                  id="entite_id"
                  v-model="entite_id"
                  @change="verif_entity()"
                  loading-text="Chargement en cours"
                  no-match-text="Entité non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre entité"
                  :remote-method="remoteEntities"
                  :loading="loading">
                  <el-option
                    v-for="item in options4"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
             <b-col md="6" v-if="exists_entity">
              <label for="agence_id">Agence *</label>
                <el-select style="display:block;"
                  id="agence_id"
                  v-model="agence_id"
                  @change="verif_agency()"
                  loading-text="Chargement en cours"
                  no-match-text="Agence non trouvée"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre agence"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options6"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text">
                  </el-option>
                </el-select>
            </b-col>
           <b-col md="6" v-if="exists_agency">
              <label for="user_id">Utilisateur *</label>
                <el-select style="display:block;"
                  id="user_id"
                  v-model="user_id"
                  loading-text="Chargement en cours"
                  no-match-text="Utilisateur non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de l'utilisateur"
                  :remote-method="remoteUsers"
                  :loading="loading">
                  <el-option
                    v-for="item in options5"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
          </b-row>
        </b-card>  
        <b-card>
          <div slot="header">
            Effectuer un <strong>Retrait</strong> 
          </div>
          <b-row class="form-group">
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="reference_benef">Réference bénéficiaire (*)</label>
              <b-form-input id="reference_benef" type="text" v-model="retrait.reference_benef" placeholder="Numéro de référence" class="form-control" :disabled="success == true"></b-form-input>
            </b-col>
            <b-col md="6">
              <label for="modelpaiement_id">Modèle du paiement du masse *</label>
              <b-form-select id="modelpaiement_id" v-model="retrait.modelpaiement_id" :plain="true" :options="options_model">
              </b-form-select>
            </b-col>
            <!--<b-col md="6">
              <label for="code_paiement">Code paiement (*)</label>
              <el-select style="display:block;"
                  id="code_paiement"
                  v-model="retrait.code_paiement"
                  :disabled="success == true"
                  loading-text="Chargement en cours"
                  no-match-text="Code de paiement non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher votre code de paiement"
                  :remote-method="remoteCode"
                  :loading="loading">
                  <el-option
                    v-for="item in options6"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
              </el-select>
            </b-col>-->
          </b-row>
         
          <div slot="footer" v-if="!success">
            <span><span v-if="!success"><b-button type="submit" size="sm" variant="primary" @click.prevent="postmontant()"><i class="fa fa-dot-circle-o"></i> Verifier</b-button></span></span>
            <span><span v-if="success"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>   
        <b-card v-if="success">
          <div slot="header">
            Effectuer un <strong>Retrait</strong> 
          </div>
          <b-row class="form-group" >
            <b-col md="6">
              <label for="piece_libelle">Type de pièces (*)</label>
               <b-form-select id="piece_libelle" v-model="piece_libelle" :plain="true" :options="options_typepiece">
              </b-form-select>
            </b-col>
            <b-col md="6">
              <label for="num_piece_benef">N° Pièce (*)</label>
              <b-form-input id="num_piece_benef" type="text" v-model="retrait.num_piece_benef" placeholder="Numéro de la pièce du bénéficiaire"></b-form-input>
            </b-col>
          </b-row>
          <div slot="footer" v-if="success">
            <span><span v-if="!success"><b-button type="submit" size="sm" variant="primary" @click.prevent="postmontant()"><i class="fa fa-dot-circle-o"></i> Verifier</b-button></span></span>
            <span><span v-if="success"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span></span>
            <b-button type="reset" size="sm" variant="danger" @click.prevent="annulerPaiement()"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>   
        <b-card class="card-accent-info" header="INFORMATION SUR LE BENEFICIAIRE" v-if="success">
            <div class="bd-example">
              <dl class="row">
                  <dt class="col-sm-2">Nom</dt>
                  <dd class="col-sm-3"> {{retrait.nom}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Prénom(s)</dt>
                  <dd class="col-sm-3"> {{retrait.prenom}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Adresse</dt>
                  <dd class="col-sm-3"> {{retrait.adresse}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Téléphone</dt>
                  <dd class="col-sm-3"> {{retrait.telephone}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Commision</dt>
                  <dd class="col-sm-3"> {{retrait.montant_commission}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Montant TTC</dt>
                  <dd class="col-sm-3"> {{retrait.montant_ttc}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Pièce libelle</dt>
                  <dd class="col-sm-3"> {{retrait.piece_libelle}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Numéro pièce</dt>
                  <dd class="col-sm-3"> {{retrait.num_piece}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Réliquat</dt>
                  <dd class="col-sm-3"> {{retrait.reliquat}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  <dt class="col-sm-2">Tarif</dt>
                  <dd class="col-sm-3"> {{retrait.tarif}} </dd>
              </dl>
              <dl class="row">
                  <dt class="col-sm-2">Montant transféré</dt>
                  <dd class="col-sm-3"> {{retrait.montant_transfere}} </dd>
                  <dt class="col-sm-1"></dt>
                  <dd class="col-sm-1"></dd>
                  
              </dl>
              <!--<dl class="row">
                  <dt class="col-sm-2">Message</dt>
                  <dd class="col-sm-10">{{message_retrait}}</dd>
              </dl>-->
            </div>
        </b-card>
        <b-card v-if="success">
                <div slot="header">
                    <strong>Information supplémentaire</strong>  
                </div>
                <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="infos_complementaire" :fixed-header="false" :pagination-options="pagination" :search-options="search">
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                          <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                     
                                <router-link :to="'/transferts/update/beneficiare/'+ props.row.id">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button>
                                </router-link>
                                <!--<router-link :to="'/transferts/paiement-masse/retrait/'">
                                  <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-money"></i> Effectuer un retrait</b-dropdown-item-button>
                                </router-link>  -->    
                            </div>     
                          </b-dropdown>
                        </span>
                        <span v-else style="font-size: 0.875rem;">
                            {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      infos_complementaire:[],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      success:false,
      options : [],
      options_typepiece : [],
      options_typeoperation : [],
      message_retrait:"",
      piece_libelle:"",
      agence_id:'',
      options_agency : [],
      options_model : [],
      retrait:{
        adresse: "",
        code_envoie: "",
        commission: "",
        date_operation: "",
        deleted_at: null,
        guichet_id: null,
        id: "",
        montant_transfere: "",
        montant_ttc: "",
        nb_benef: "",
        nom: "",
        num_piece: null,
        num_transaction: "",
        prenom: "",
        statut: "",
        telephone: "",
        tva: "",
        typeoperation_id: "",
        typepiece_id: "",
        updated_at: "",
        user_id: null,
        code_paiement:'',
        modelpaiement_id:''
      },
      exist_num:true,
      atm:[],
      typepiece:[],
      typeoperation:[],
      serverParams: {
          page:1,
          current_page: 1,
          paginate: 10
        },
      options4: [],
      options: [],
      options5: [],
      options6: [],
      value9: [],
      list: [],
      loading: false,
      states: [],
      entite_id:'',
      user_id:'',
      entities:[],
      codes:[],
      users:[],
      options : [],
      t_agency : [],
      options_code : [],
      options_user : [],
      options_agency : [],
      displayCentreData:false,
      exists_entity:false,
      columns: [],
      rows: [],
      search:{
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
      },
      pagination:{
        enabled: false,
        mode: 'records',
        perPage: 10,
        position: 'top',
        perPageDropdown: [3, 10, 100],
        dropdownAllowAll: false,
        setCurrentPage: 2,
        nextLabel: 'Précédent',
        prevLabel: 'Suivant',
        rowsPerPageLabel: 'Ligne par page',
        ofLabel: 'de',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }
    }
  },
  methods:{
    // async post(){     
    //     await this.$store.dispatch('mandate/getInfobyNumTrans',this.mandats.num_transaction)
    //     //this.reset()
    // },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    goBack() {
        this.$router.go(-1)
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    // isexiste(){
    //   if(this.retrait.num_transaction!=""){
    //     console.log(this.retrait.num_transaction)
    //     this.exist_num = true
    //   }else{this.exist_num=false}
    // },
    async updateSolde(){
        let solde = await api.atm.get_auth_guichets(token)
        localStorage.setItem('solde', solde.data.data.solde)
    },
    async get_all_typepieces(){
          //this.typepiece = store.getters['typepiece/rows'];
          await this.$store.dispatch('typepiece/get_all_typepieces',this.serverParams).then(()=>{
            return this.typepiece =  store.getters['typepiece/rows'];
          })
          this.typepiece.forEach((element)=>{
              this.options_typepiece.push({
                value:element.libelle,
                text:element.libelle
              })
          })
    },
    async annulerPaiement(){
      
      let d = {
        reference_benef:this.retrait.reference_benef,
        modelpaiement_id:this.retrait.modelpaiement_id
      }
      if(this.displayCentreData==true){
          let centre = {
              entite_id:this.entite_id,
              operateur_id:this.user_id
          }
          Object.assign(d,centre)
        }
        this.response = await this.$store.dispatch('mandate/AnnulerPaiement',d)  
        this.showAlert()   
        if(this.response.success==true){
            this.retrait.reference_benef="",
            this.retrait.modelpaiement_id=""
            this.success=false
        }

    },
    async get_all_model(){
          // this.userConnected = await store.getters['auth/get_user']
          // let serverParams = {
          //     name:'',
          //     email:'',
          //     entite_nom:'',
          //     agence_nom:'',
          //     agence_ville:'',
          //     role_name:'',
          //     created_at:'',
          //     page:1,
          //     current_page: 1,
          //     nb_lines:10

          // }
          await this.$store.dispatch('mandate/get_all_model').then(()=>{
              return this.model = store.getters['mandate/rowsModels'];    
          })
          this.model.forEach((element)=>{
              this.options_model.push({
                value:element.id,
                text:element.model.toUpperCase()
              })
          }) 
           
    },
    async postmontant(){   
        let d = {
                  reference_benef:this.retrait.reference_benef,
                  modelpaiement_id:this.retrait.modelpaiement_id
                  //piece_libelle:this.piece_libelle,
                  //num_piece_benef:this.retrait.num_piece_benef
                }  
        if(this.displayCentreData==true){
          let centre = {
              entite_id:this.entite_id,
              operateur_id:this.user_id
          }
          Object.assign(d,centre)
        }
        let response = await this.$store.dispatch('mandate/getInfoPaiement',d)     

        if(response.success==true){
        
          this.success=true
          this.retrait.adresse= response.data.adresse,
          this.retrait.num_transaction= this.retrait.num_transaction,
          this.retrait.commission= response.data.commission,
          this.retrait.date_operation= response.data.date_operation,
          this.retrait.deleted_at= response.data.deleted_at,
          this.retrait.guichet_id= response.data.guichet_id,
          this.retrait.id= response.data.id,
          this.retrait.montant_transfere= response.data.montant_transfere,
          this.retrait.montant_ttc= response.data.montant_ttc,
          this.retrait.nb_benef= response.data.nb_benef,
          this.retrait.nom= response.data.nom,
          this.retrait.num_piece= response.data.num_piece,
          //this.retrait.num_transaction= response.data.num_transaction,
          this.retrait.prenom= response.data.prenom,
          this.retrait.statut= response.data.statut,
          this.retrait.telephone= response.data.telephone,
          this.retrait.tva= response.data.tva,
          this.retrait.typeoperation_id= response.data.typeoperation_id,
          this.retrait.typepiece_id= response.data.typepiece_id,
          this.retrait.updated_at= response.data.updated_at,
          this.retrait.user_id= response.data.user_id
          this.retrait.centre_appel= response.data.centre_appel
          this.retrait.groupage= response.data.groupage
          this.retrait.montant_commission= response.data.montant_commission
          this.retrait.montant_tva= response.data.montant_tva
          this.retrait.code_paiement= response.data.groupage

          this.infos_complementaire.push(JSON.parse(response.data.infos_dynamique))
          for (var key in JSON.parse(response.data.infos_dynamique)){
              var found = this.columns.find(function(element1) {
                  return element1.field === key;
              });
              if(found == undefined){
                this.columns.push({
                  label: key,
                  field: key,
                  filterable: false,
                  thClass: 'custom-th-class',
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: 'Filter This Thing', // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [], // dropdown (with selected values) instead of text input
                    filterFn: this.columnFilterFn, //custom filter function that
                    trigger: 'keyup', //only trigger on enter not on keyup 
                  }
              })
            }
          }
        }else{
          this.success=false
          this.response = response
          this.showAlert()
          
        }
          this.message_retrait = response.message
    },
    scrollToTop() {
        window.scrollTo(0,0);
    },
    async post(){
        let d = {
                  reference_benef:this.retrait.reference_benef,
                  code_paiement:this.retrait.groupage,
                  piece_libelle:this.piece_libelle,
                  num_piece_benef:this.retrait.num_piece_benef
                } 
        if(this.displayCentreData==true){
          let centre = {
              entite_id:this.entite_id,
              operateur_id:this.user_id
          }
          Object.assign(d,centre)
        }
        this.response = await this.$store.dispatch('mandate/validateInfoPaiement',d)     
        this.showAlert()
        this.scrollToTop()
        this.reset()
        if(this.response.success == true){
          let solde = await api.atm.get_auth_guichets(token)
          localStorage.setItem('solde', solde.data.data.solde)
          window.open(this.response.data.content, "_blank")
          setTimeout(function(){ location.reload(); }, 3000);
        }
    },
    reset(){
        this.success = false
        this.retrait.code_envoie= "",
        this.piece_libelle= ""
        this.retrait.num_transaction= ""
        this.retrait.num_piece_benef= ""
    },
    remoteEntities(query) {
        this.get_all_entities(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options4 = this.t.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          
        } else {
          this.options4 = [];
        }
        this.options = [] 
    },
    remoteCode(query) {
        this.get_all_code_paiement(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            
            this.loading = false;
            this.options6 = this.c.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          
        } else {
          this.options6 = [];
        }
        
        this.options_code = [] 
    },
    remoteUsers(query) {
        this.get_all_users_by_entity(query)
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.t_user.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
          
        } else {
          this.options5 = [];
        }
        this.options_user = [] 
    },
    remoteAgencies(query) {
      this.get_all_agencies_by_entity(query)
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options6 = this.t_agency.filter(item => {
            return item.text.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
        
      } else {
        this.options6 = [];
      }
      this.options_agency = [] 
    },
    async get_auth_roles(){
        let response = await this.$store.dispatch('role/get_auth_roles',localStorage.getItem('token'))
        response.data.forEach((element)=>{
          if(element.toUpperCase()=='CENTRE APPEL'){
              this.displayCentreData=true
          }
        })
    },
    async get_all_entities(query){
        let serverParams= {
          page:1,
          current_page: 1,
          paginate: 10,
          nom_commercial: query,
        }
        await this.$store.dispatch('entity/get_all_entities',serverParams).then(()=>{
          return this.entities = store.getters['entity/rows'];    
        })
        this.entities.forEach((element)=>{
            this.options.push({
              value:element.id,
              text:element.nom_commercial.toUpperCase(),
            })
        })
        this.t = this.options
    },
    async get_all_code_paiement(query){
        let serverParams= {
          page:1,
          current_page: 1,
          paginate: 10,
          code_paiement: query,
        }
        await this.$store.dispatch('mandate/get_all_code_paiement',serverParams).then((re)=>{
          //console.log("données entrantes : ",re)
          return this.codes = store.getters['mandate/getCodes'];    
        })
        
        this.codes.forEach((element)=>{
            this.options_code.push({
              value:element.code_paiement,
              text:element.code_paiement,
            })
        })
        this.c = this.options_code

    },
    verif_entity(){
      console.log(this.entite_id)
      if(this.entite_id && this.entite_id != ''){
        this.exists_entity=true
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }else{
        this.exists_entity=false
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }
    },
    verif_agency(){
      
      if(this.agence_id && this.agence_id != ''){
        this.exists_agency=true
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }else{
        this.exists_agency=false
        this.user_id=''
        this.options5=[]
        this.options_user=[]
      }
    },
    async get_all_users_by_entity(query){
        let serverParams= {
          entite_id:this.entite_id,
          page:1,
          current_page: 1,
          paginate: 10,
          name: query,
        }
        await this.$store.dispatch('user/get_all_users_by_entity',serverParams).then(()=>{
          return this.users = store.getters['user/rows'];    
        })
        let y = this.users.filter(element=>element.role_name.search("Operateur")!=-1)
        y = y.filter(element=>element.agence_nom.search(this.agence_id)!=-1)
        
        y.forEach((element)=>{
            this.options_user.push({
              value:element.id,
              text:element.name.toUpperCase(),
            })
        })
        this.t_user = this.options_user
    },
    async get_all_agencies_by_entity(query){
        let serverParams= {
          entite_id:this.entite_id,
          page:1,
          current_page: 1,
          paginate: 10,
          name: query,
        }

        await this.$store.dispatch('agency/get_all_agencies_by_entity',serverParams).then(()=>{
          return this.agences = store.getters['agency/rows'];    
        })
        //let y = this.users.filter(element=>element.role_name.search("Operateur")!=-1)
        this.agences.forEach((element)=>{
            this.options_agency.push({
              value:element.id,
              text:element.nom_agence.toUpperCase(),
            })
        })
        this.t_agency = this.options_agency
    }
  },
  mounted(){
    this.updateSolde()
    this.get_all_typepieces()
    this.get_all_code_paiement('')
    this.get_auth_roles()
    this.get_all_model()
    // this.get_all_typepieces()
    // this.get_all_typeoperations()
    // this.get_all_mandates()
  }
}
</script>
